import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "../../store";
import {
  addFolder,
  selectFolders,
  selectFolder,
  editFolder,
} from "@src/store/slices/menu";
import {
  Modal,
  Button,
  Grid,
  TextField,
  useTheme,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";

const AddEditFolderModal = ({
  isVisible,
  onDismiss,
  selectedFolder = undefined,
  isChildFolder = false,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const folders = useSelector((state) => selectFolders(state));
  const folder = useSelector(selectFolder(selectedFolder || ""));

  const [contactForm, setContactForm] = useState({
    title: "",
    parentId: "",
  });

  useEffect(() => {
    setContactForm({
      title: folder?.title || "",
      parentId: isChildFolder ? folder?.parentId || "" : "",
    });
  }, [isVisible, selectedFolder]);

  const handleDismiss = () => {
    setContactForm({
      title: "",
      parentId: "",
    });
    onDismiss();
  };

  const onAddFolder = async () => {
    if (selectedFolder) {
      dispatch(
        editFolder({
          id: selectedFolder,
          name: contactForm.title,
          parentId: contactForm.parentId ? contactForm.parentId : null,
          icon: "folder-icon",
        })
      );
    } else {
      dispatch(
        addFolder({
          name: contactForm.title,
          parentId: contactForm.parentId ? contactForm.parentId : null,
          icon: "folder-icon",
        })
      );
    }

    handleDismiss();
  };

  return (
    <Modal
      open={isVisible}
      onClose={handleDismiss}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "90%",
          backgroundColor: "white",
          borderRadius: 3,
          padding: theme.spacing(2),
        }}
      >
        <Grid container spacing={2} direction="row">
          <Grid item xs={12}>
            <Typography variant="h3" component="h2">
              Add Folder
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              id="title"
              label="Title"
              value={contactForm.title}
              onChange={(event) =>
                setContactForm((prev) => ({
                  ...prev,
                  title: event.target.value,
                }))
              }
            />
          </Grid>

          {(isChildFolder || !selectedFolder) && folders.length > 0 && (
            <Grid item xs={12}>
              <Typography sx={{ mb: 1, fontWeight: "bold" }}>Parent</Typography>
              <FormControl sx={{ minWidth: 120 }} fullWidth>
                <Select
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                  value={contactForm.parentId}
                  onChange={(event) =>
                    setContactForm((prev) => ({
                      ...prev,
                      parentId: event.target.value,
                    }))
                  }
                >
                  <MenuItem value="">
                    <em>No parent</em>
                  </MenuItem>
                  {folders.map(({ id, title }) => (
                    <MenuItem key={id} value={id}>
                      {title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} align="right">
            <Button sx={{ color: "red" }} onClick={handleDismiss}>
              Cancel
            </Button>
            <Button sx={{ color: "green" }} onClick={onAddFolder}>
              {selectedFolder ? "Update" : "Add"}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddEditFolderModal;
